import { render, staticRenderFns } from "./SingleCollection.vue?vue&type=template&id=78a8561a&scoped=true&"
import script from "./SingleCollection.vue?vue&type=script&lang=js&"
export * from "./SingleCollection.vue?vue&type=script&lang=js&"
import style0 from "./SingleCollection.vue?vue&type=style&index=0&id=78a8561a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a8561a",
  null
  
)

export default component.exports